import { Box, Button, Divider, Typography } from "@mui/material";
import {
  clearImgData,
  getImgData,
  getMyModuleServer,
  getPathData,
  importAIModules,
  removeAIModules,
  sendImgDataFromStorage,
  updateAIModules,
} from "common-lib";
import { startTrain } from "../../services/visionService";
import testPayloads from "../../datas/annotationTest.json";
import { useState } from "react";

type AnnotationData = {
  paths: string[];
  annotation: Annotation[];
};

type Annotation = {
  type: "MultiPolygon";
  coordinates: number[][][][];
  properties: {
    label_list: string[];
    id: number;
  };
};

const AI_SERVER = "127.0.0.1:50051";
const MDOEL_UUID = "annotation_test";
const PROJECT_ID = "annotation_test"; //실제로는 projectId
const PATH_LIST_1 = "/data1/datasets/SkySoftGel/260126/RED/OK";

const getFilePaths = (data: {
  contents: {
    current_path: string;
    file: string[];
  };
}) => {
  const { current_path, file } = data.contents;

  return file
    .slice(0, 100) //파일 수가 많아 임의로 100개만
    .map((filename) => `${current_path}/${filename}`);
};

function convertAnnotation(annotationData: any, tagID: string) {
  return {
    path: annotationData["paths"][0],
    code: {
      image_id: 1,
      annotation: annotationData["annotation"],
      tag: [tagID],
      destination: {
        "ai-1": ["tag"],
      },
    },
  };
}

const UPDATE_AI_MODULES_PAYLOAD_KEYS = {
  show: "showUpdateAIModules",
  train: "trainUpdateAIModules",
  infer: "inferUpdateAIModules",
  scoremap: "scoremapUpdateAIModules",
  preprocess: "preprocessUpdateAIModules",
} as const;

type UpdateModuleMode = keyof typeof UPDATE_AI_MODULES_PAYLOAD_KEYS;

export default function AnnotationTest() {
  const [imageList, setImageList] = useState<string[]>([]);
  const handleImport = async () => {
    await importAIModules(PROJECT_ID, false, false, true, AI_SERVER, null, MDOEL_UUID);
  };

  const handleGetModule = async () => {
    await getMyModuleServer(PROJECT_ID, null);
  };

  const handleUpdateModule = async (mode: UpdateModuleMode) => {
    const cfg = testPayloads[UPDATE_AI_MODULES_PAYLOAD_KEYS[mode]];
    const data = await updateAIModules(AI_SERVER, cfg.updateData, cfg.myAIModule);
    console.log(data);
  };

  const handleRemoveModule = async () => {
    await removeAIModules(AI_SERVER, PROJECT_ID);
  };

  // (id: any, uuid: any, data: any, dataset_path: any, auto_valid: any, ip: any, epoch: any, saveOption: any, parentModel: any):
  const handleStartTrain = async () => {
    const response = await getPathData(PATH_LIST_1);
    const pathList = getFilePaths(response);
    console.log("response", response);

    // await startTrain(PROJECT_ID, PROJECT_ID, pathList, "", false, AI_SERVER);
  };

  const handleAnnotation = async () => {
    const epoch = 1;

    const cfg = testPayloads.trainWithAnnotation;
    const baseItems = cfg.datasets.flatMap((ds) => ds.paths.map((path) => ({ path, annotation: ds.annotation })));
    console.log("baseItems", baseItems);
    const totalCount = baseItems.length * epoch;

    let sent = 0;
    for (let e = 0; e < epoch; e++) {
      for (const item of baseItems) {
        const sendData = {
          uuid: PROJECT_ID,
          path: item.path,
          destination: testPayloads.sendImgDataFromStorage.destination,
          annotation: item.annotation,
        };
        console.log("sendData", sendData);
        try {
          await sendImgDataFromStorage(AI_SERVER, sendData);
        } catch (error) {
          console.error(`trainWithAnnotation 전송 실패 (${sent + 1}/${totalCount}):`, error);
        }
        sent += 1;
      }
    }
    // await clearImgData(AI_SERVER, PROJECT_ID);
    console.log({
      specID: PROJECT_ID,
      pack: convertAnnotation(cfg.datasets[0], PROJECT_ID),
    });
  };

  const handleGetResultImage = async () => {
    const response = await getImgData(AI_SERVER, PROJECT_ID);
    setImageList(response.scoremap);
  };

  const handleClearImage = async () => {
    await clearImgData(AI_SERVER, PROJECT_ID);
  };

  return (
    <Box>
      <Typography>127.0.0.1 환경에서의 annotation test</Typography>
      <Box
        sx={{
          display: "grid",
          width: "100%",
          gap: 1,
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        }}
      >
        <Button variant="contained" size="small" onClick={handleImport}>
          Import AI Module
        </Button>
        <Button variant="contained" size="small" onClick={handleGetModule}>
          Get AI Module
        </Button>
        <Button variant="contained" onClick={handleRemoveModule}>
          Remove AI Module
        </Button>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Typography>AI Module 업데이트</Typography>
      <Box
        sx={{
          display: "grid",
          width: "100%",
          gap: 1,
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        }}
      >
        {(Object.keys(UPDATE_AI_MODULES_PAYLOAD_KEYS) as UpdateModuleMode[]).map((mode) => (
          <Button variant="contained" key={mode} onClick={() => handleUpdateModule(mode)}>
            {mode}
          </Button>
        ))}
      </Box>
      <Divider sx={{ my: 1 }} />
      <Typography>AI 학습 및 결과 확인</Typography>
      <Box
        sx={{
          display: "grid",
          width: "100%",
          gap: 1,
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        }}
      >
        <Button variant="contained" onClick={handleStartTrain}>
          Start General Train
        </Button>

        <Button variant="contained" onClick={handleAnnotation}>
          Start Annotation Train
        </Button>
        <Button variant="contained" onClick={handleClearImage}>
          Clear Image
        </Button>
        <Button variant="contained" onClick={handleGetResultImage}>
          Get Result Image
        </Button>
      </Box>
      {imageList.length > 0 && (
        <Box sx={{ display: "flex", width: "100%" }}>
          {imageList.map((item, index) => (
            <img
              key={index}
              src={item}
              style={{
                flex: 1,
                width: 0,
                objectFit: "contain",
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
